import { CSSProperties } from 'react';

import styled from '@emotion/styled';

export type SlideCardProps = {
  frontElement?: React.ReactNode;
  backElement?: React.ReactNode;
  size: number;
  cardStyle?: CSSProperties;
};

const SlideCardStyle = styled.div`
  width: ${(props: SlideCardProps) => props.size}px;
  height: ${(props: SlideCardProps) => props.size}px;
  overflow: hidden;

  .card-container {
    transition: transform 0.2s ease-in-out;
    &:hover {
      transform: translate3d(0px, -${(props: SlideCardProps) => props.size}px, 0px);
    }
    .card {
      height: ${(props: SlideCardProps) => props.size}px;
      width: ${(props: SlideCardProps) => props.size}px;
    }
  }
`;

export default SlideCardStyle;
